<!-- start page title -->
<app-pagetitle title="Range Slider" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<!-- end page title -->

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Range slider</h4>
                <p class="card-title-desc">Cool, comfortable, responsive and easily customizable range slider</p>
                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Default</h5>
                            <ngx-slider [(value)]="defaultVal" [options]="defaultOption"></ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Min-Max</h5>
                            <ngx-slider [(value)]="minValue" [options]="minOptions"></ngx-slider>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Prefix</h5>
                            <ngx-slider [(value)]="prefixValue" [(highValue)]="prefix" [options]="prefixOption">
                            </ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Range</h5>
                            <ngx-slider [(value)]="rangValue" [(highValue)]="rang" [options]="rangOption"></ngx-slider>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Step</h5>
                            <ngx-slider [(value)]="stepValue" [(highValue)]="step" [options]="stepOption"></ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Custom Values</h5>
                            <ngx-slider [(value)]="tickValue" [options]="tickValueoptions"></ngx-slider>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Prettify Numbers</h5>
                            <ngx-slider [(value)]="prettifyValue" [options]="prettifyOption"></ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Disabled</h5>
                            <ngx-slider [(value)]="disabledValue" [options]="disabledOption"></ngx-slider>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Extra Example</h5>
                            <ngx-slider [(value)]="extraValue" [options]="extraOption"></ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Use decorate_both option</h5>
                            <ngx-slider [(value)]="decorateValue" [(highValue)]="decorate" [options]="decorateOption">
                            </ngx-slider>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Postfixes</h5>
                            <ngx-slider [(value)]="postfixesValue" [options]="postfixesOption"></ngx-slider>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="p-3">
                            <h5 class="font-size-14 mb-3 mt-0">Hide</h5>
                            <ngx-slider [(value)]="hideValue" [(highValue)]="hide" [options]="hideOption"></ngx-slider>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>